var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_456_4510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.39893C0 1.07236 1.07388 0 2.4 0H21.6C22.9261 0 24 1.07236 24 2.39893V16.7895C24 18.1161 22.9261 19.1885 21.6 19.1885H12.2665L6.0798 23.8255C5.83737 24.0072 5.51308 24.0364 5.24212 23.9008C4.97115 23.7653 4.8 23.4883 4.8 23.1854V19.1885H2.4C1.07388 19.1885 0 18.1161 0 16.7895V2.39893ZM6.4 6.3958H17.6V7.9958H6.4V6.3958ZM6.4 11.1927H14.4V12.7927H6.4V11.1927Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_456_4510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.bcb85a9458e34cb698a690f2e70fffef.svg";
export { ForwardRef as ReactComponent };